import { Action, InputType } from '@projectstorm/react-canvas-core';
import { PortModel } from '@projectstorm/react-diagrams';

export default class FixForLinkAction extends Action {
  constructor() {
    super({
      type: InputType.MOUSE_UP,
      fire: event => {
        if(event.event.nativeEvent.button === 0) {
          const model = this.engine.getMouseElement(event.event);
          const link = Object.values(this.engine.model.activeLinkLayer.models).find(val => val.targetPort === null)
          if(!link) {
            return
          }
          if (model instanceof PortModel) {
            if (link.sourcePort.canLinkToPort(model)) {
              link.setTargetPort(model);
              model.reportPosition();
              this.engine.repaintCanvas();
              return;
            } else {
              link.remove();
              this.engine.repaintCanvas();
              return;
            }
          }
          link.remove();
          this.engine.repaintCanvas();
        }
      }
    });
  }
}